export enum ShipmentLabelType {
  LabelTypePdf = 'pdf',
  LabelTypeQr = 'qr',
  LabelTypeCode = 'code',
}

export enum DeadlineExtensionStatus {
  Pending = 1,
  Accepted = 10,
  Cancelled = 20,
}

export enum DeliveryOptionChangeRequestStatus {
  Accepted = 10,
  Cancelled = 20,
}
